import React from 'react';

const ExpenseListGrid = ({ expenses, onEdit, onDelete, userProfile, getPayerDisplay, getPaymentStyle }) => {
    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '15px' }}>
            {expenses.map((item) => {
                const paymentStyle = getPaymentStyle(item.payment_method_id ?? item.payment_method);
                const isCreatedByMe = item.user_id === userProfile?.userId;
                return (
                    <div 
                        key={item.id}
                        onClick={() => onEdit(item)}
                        style={{
                            backgroundColor: 'var(--color-glass-strong)',
                            borderRadius: '16px',
                            padding: '16px',
                            boxShadow: '0 12px 24px rgba(30, 70, 90, 0.12)',
                            border: '1px solid var(--color-border)',
                            cursor: 'pointer',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '8px'
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                            <div>
                                <div style={{ fontSize: '12px', color: 'var(--color-text-subtle)' }}>
                                    {new Date(item.occurred_at).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
                                </div>
                                <div style={{ fontSize: '13px', color: 'var(--color-text-muted)', marginTop: '2px', fontWeight: '500' }}>
                                    จ่ายโดย: {getPayerDisplay(item)}
                                </div>
                                {!isCreatedByMe && <div style={{ fontSize: '11px', color: 'var(--color-accent)', marginTop: '2px', backgroundColor: 'var(--color-accent-soft)', display: 'inline-block', padding: '2px 6px', borderRadius: '4px' }}>บันทึกโดย {item.creator?.display_name || 'เพื่อน'}</div>}
                            </div>
                            <button 
                                onClick={(e) => { e.stopPropagation(); onDelete(item.id); }}
                                style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--color-danger)', padding: '4px' }}
                            >
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                            </button>
                        </div>
                        
                        <div style={{ fontSize: '16px', fontWeight: '500', color: 'var(--color-text)', margin: '4px 0' }}>
                            {item.note || '-'}
                        </div>
                        {item.trips && (
                            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', marginBottom: '8px', padding: '2px 8px', backgroundColor: 'var(--color-accent-soft)', borderRadius: '12px', fontSize: '11px', color: 'var(--color-accent)', alignSelf: 'flex-start' }}>
                                <span>{item.trips.icon || '✈️'}</span> {item.trips.name}
                            </div>
                        )}

                        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginTop: 'auto' }}>
                            <div style={{ fontWeight: 'bold', color: paymentStyle.color, fontSize: '18px', display: 'flex', alignItems: 'center' }}>
                                {item.amount.toLocaleString()} {item.currency}
                                {paymentStyle.icon}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default ExpenseListGrid;
